import { render } from "./PrivateView.vue?vue&type=template&id=4c85c85c&scoped=true"
import script from "./PrivateView.vue?vue&type=script&lang=js"
export * from "./PrivateView.vue?vue&type=script&lang=js"

import "./PrivateView.vue?vue&type=style&index=0&id=4c85c85c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c85c85c"]])

export default __exports__